import { ReactElement } from 'react';
import { TooltipCellWrapper } from '../TooltipCellWrapper';
import NoData from '../../../../batteryHealth/common/NoData';

export const ConsumptionCell = ({ value }: { value?: number }): ReactElement => {
    return value !== undefined ? <TooltipCellWrapper content={`${value} kWh/km`} /> : <NoData hasTooltip={false} />;
};
